import cmp from './VendorProfileLayout'

export default cmp
